interface Props {
  name: string;
  vendor: string;
  client: string;
  term: string;
  start: string;
  end: string;
  Buy_price_per: string;
  sell_price_per: string;
  Buy_price_total: string;
  sell_price_total: string;
  margin: string;
  amount: string;
}

const License = ({
  name,
  vendor,
  client,
  term,
  start,
  end,
  Buy_price_per,
  Buy_price_total,
  sell_price_per,
  sell_price_total,
  margin,
  amount,
}: Props) => {
  return (
    <div className="w-[132vw] text-black border-b-2 border-gray-300 p-2 flex items-center text-sm hover:bg-gray-50">
      <p className="w-[10vw] pr-[2%]">{amount}</p>
      <p className="w-[20vw]">{name}</p>
      <p className="w-[10vw]">{vendor}</p>
      <p className="w-[20vw]">{client}</p>
      <p className="w-[10vw]">{term}</p>
      <p className="w-[10vw]">{start}</p>
      <p className="w-[10vw]">{end}</p>
      <p className="w-[10vw]">{Buy_price_per}</p>
      <p className="w-[10vw]">{sell_price_per}</p>
      <p className="w-[10vw]">{Buy_price_total}</p>
      <p className="w-[10vw]">{sell_price_total}</p>
      <p className="w-[10vw]">{margin}</p>
    </div>
  );
};

export default License;
